import { usePresenter, useUseCase } from '@magicdoor/magic-use-case-solid';
import { Style } from '@solidjs/meta';
import { createAsync } from '@solidjs/router';
import { Component, JSX, Show } from 'solid-js';
import { renderContext } from '~/platform/renderContext';
import { presentCompanyStyle } from '~/presenters/CompanyStylePresenter';
import { OpenCompanySiteUseCase } from '~/use-cases/companyInfo/openCompanySiteUseCase';
import { getCurrentHostName } from '~/utils/host';

interface CompanyStylingProps {
  children: JSX.Element;
}

export const useStyling = () => {
  const { model } = usePresenter(presentCompanyStyle);
  return { companyStyling: model };
};

export const CompanyStyling: Component<CompanyStylingProps> = (props) => {
  const { execute: openSite } = useUseCase(OpenCompanySiteUseCase);
  const isSiteLoaded = createAsync(() =>
    openSite({ host: getCurrentHostName(), pageUrl: renderContext.pageUrl(), isDev: import.meta.env.DEV }).then(() => true)
  );
  const { companyStyling } = useStyling();

  return (
    <>
      <Style>
        {`
        :root {
          --primary-color: ${companyStyling()?.primaryColor};
          --hover-color: ${companyStyling()?.hoverColor};
          --active-color: ${companyStyling()?.activeColor};
          --gradient-color-start: ${companyStyling()?.gradientStartColor};
          --gradient-color-end: ${companyStyling()?.gradientEndColor};
        }
      `}
      </Style>
      <Show when={isSiteLoaded()}>{props.children}</Show>
    </>
  );
};
